import { render, staticRenderFns } from "./MembersView.vue?vue&type=template&id=3cbe2356&scoped=true"
import script from "./MembersView.vue?vue&type=script&lang=ts"
export * from "./MembersView.vue?vue&type=script&lang=ts"
import style0 from "./MembersView.vue?vue&type=style&index=0&id=3cbe2356&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbe2356",
  null
  
)

export default component.exports